import { FC, useEffect, useState } from "react";
import { Check } from "lucide-react";

import { BooleanVoidFunc } from "../../helpers/functions/types";
import { SMALL_ICON_SIZE_STYLES } from "../../ui/styles";

type FiltersSwitchProps = {
  title: string;
  value?: boolean;
  onChange: BooleanVoidFunc;
  disabled?: boolean;
  customId?: string;
};

export const FiltersSwitch: FC<React.PropsWithChildren<FiltersSwitchProps>> = ({
  title,
  value,
  onChange,
  disabled = false,
  customId,
}) => {
  const [fieldValue, setFieldValue] = useState(value);
  const inputId = customId ?? title;

  const handleChange = (value: boolean) => {
    onChange(value);
  };

  useEffect(() => {
    setFieldValue(value);
  }, [value]);

  return (
    <label
      htmlFor={inputId}
      className={`rounded-md px-3 py-2 transition-colors duration-500 cursor-pointer disabled:cursor-not-allowed ${
        fieldValue
          ? "bg-stone-700 text-white dark:bg-stone-300 dark:text-stone-900"
          : "bg-stone-200 text-stone-600 dark:bg-stone-700 dark:text-stone-300"
      } text-sm`}
    >
      {
        <input
          className="invisible w-0"
          type="checkbox"
          id={inputId}
          checked={fieldValue}
          onChange={() => {
            if (!disabled) handleChange(!fieldValue);
          }}
        />
      }
      {fieldValue && (
        <Check
          className={`mr-1.5 inline-block self-center text-white dark:text-stone-900 ${SMALL_ICON_SIZE_STYLES}`}
        />
      )}
      {title}
    </label>
  );
};
